import Button from '../Button/Button'
import { MoonIcon, SunIcon } from '../Icon/Icon'
import { useTheme } from '../../../contexts/ThemeContext'

const ThemeToggle = ({ size = 'md' }) => {
  const { theme, toggleTheme } = useTheme()
  const nextTheme = theme === 'dark' ? 'light' : 'dark'

  return (
    <Button
      variant="icon"
      size={size}
      onClick={toggleTheme}
      aria-label={`Switch to ${nextTheme} theme`}
      title={`Switch to ${nextTheme} theme`}
    >
      {theme === 'dark' ? <SunIcon size={18} /> : <MoonIcon size={18} />}
    </Button>
  )
}

export default ThemeToggle
